import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import selectedChatSlice, { setSelectedChat } from "./slices/selectedChatSlice";
import userSlice, { setUser } from "./slices/userSlice";
const rootReducer = combineReducers({
  activeChat: selectedChatSlice,
  user: userSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const user = JSON.parse(localStorage.getItem("user-data"));
store.dispatch(setUser(user));
const selectedUser = JSON.parse(localStorage.getItem("selectedUser"));
store.dispatch(setSelectedChat(selectedUser));

export default store;
